import type {ValidationError} from 'schemaDefinition/types';
import type {ValidationResult} from './types';
import {addValidationError} from './addValidationError';

export const warning = (
  error: Omit<ValidationError, 'level'>,
  aggregateResult: ValidationResult,
): ValidationResult =>
  addValidationError({level: 'warning', ...error}, aggregateResult);
